
import {serializable, alias, object, list, primitive} from 'serializr';

export class CompanyAddress { 

	@serializable(alias('id', primitive()))
	id?: number;

	@serializable(alias('street', primitive()))
	street?: string;

	@serializable(alias('province', primitive()))
	province?: string;

	@serializable(alias('locality', primitive()))
	locality?: string;

	@serializable(alias('postal_code', primitive()))
	postalCode?: string;

	@serializable(alias('country', primitive()))
	country?: string;

	@serializable(alias('city', primitive()))
	city?: string;

	@serializable(alias('company_id', primitive()))
	companyId?: number;

	@serializable(alias('updatedAt', primitive()))
	updatedAt?: string;

	@serializable(alias('createdAt', primitive()))
	createdAt?: string;

	@serializable(alias('status', primitive()))
	status?: string;

}